import identity from 'transmute/identity';
// @ts-expect-error file is untyped
import { createAction } from 'flux-actions';
import uniqueId from 'transmute/uniqueId';
import { Map as ImmutableMap } from 'immutable';
import UserContainer from 'documents-ui/lib/containers/UserContainer';
import getUserView from 'documents-ui/lib/getUserView';
import { addAlert } from 'documents-lib/js/utils/addAlert';
import { documentToSearchResultCHIRP } from 'documents-ui/utils/documentToSearchResult';
import { DOCUMENT_CREATE_FAILED, DOCUMENT_CREATE_STARTED, DOCUMENT_CREATE_SUCCEEDED } from 'documents-lib/js/constants/ActionTypes';
import { uploadFileCHIRP } from 'documents-ui/api/UploadChirpApi';
import * as DocumentsApi from 'documents-ui/api/DocumentsApi';
import IndexUIActions from 'SalesContentIndexUI/data/actions/IndexUIActions';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
import SearchContentTypes from 'SalesContentIndexUI/data/constants/SearchContentTypes';
const uploadDocumentStarted = createAction(DOCUMENT_CREATE_STARTED, identity);
const uploadDocumentSucceeded = createAction(DOCUMENT_CREATE_SUCCEEDED, identity);
const uploadDocumentFailed = createAction(DOCUMENT_CREATE_FAILED, identity);
const createTempSearchResult = (name, folderId) => {
  const createdAt = new Date().valueOf();
  return SearchResultRecord({
    name,
    createdAt,
    id: uniqueId('document-temp-id-'),
    contentType: SearchContentTypes.DOCUMENT,
    updatedAt: createdAt,
    userId: UserContainer.get().user_id,
    metadata: ImmutableMap({
      numShares: 0,
      numViews: 0,
      progress: 0
    }),
    userView: getUserView(),
    folderId
  });
};
export default (({
  file,
  fileName,
  folderId
}) => async dispatch => {
  const tempDocument = createTempSearchResult(fileName, folderId);
  const tempId = tempDocument.id;
  dispatch(uploadDocumentStarted(tempId));
  IndexUIActions.addResult(tempDocument);
  const handleUploadProgress = percent => {
    IndexUIActions.updateResult(tempDocument.setIn(['metadata', 'progress'], percent));
  };
  try {
    const {
      documentId
    } = await uploadFileCHIRP({
      file,
      onProgress: handleUploadProgress
    });
    const documentData = await DocumentsApi.fetchDocumentCHIRPEarlyRequest(documentId);
    addAlert('uploadFile', 'success', {
      name: documentData.title
    });
    dispatch(uploadDocumentSucceeded(tempId));
    IndexUIActions.replaceResult({
      idToReplace: tempId,
      replacementResult: documentToSearchResultCHIRP(documentData, UserContainer.get().user_id)
    });
    return documentData;
  } catch (_e) {
    addAlert('uploadFile', 'danger', {
      name: fileName
    });
    dispatch(uploadDocumentFailed(tempId));
    IndexUIActions.removeResult(tempId);
    return null;
  }
});